import GlobalStyleProvider from "./GlobalStyleProvider";
import React from "react";
import { cloud } from "@vitalsource/vstui/colors";

const globalStyles = `
  *,
  *:before,
  *:after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-size: 1em;
    font-weight: inherit;
    border: 0;
    background: transparent;
    border-radius: 0;
  }

  html {
    color: ${cloud.getShade(10)};
  }
  
  textarea,
  input[type="text"],
  input[type="password"],
  input[type="email"] {
    -webkit-appearance: none;
  }
  
  button {
    cursor: pointer;
  }
  
  button:active {
    color: currentColor;
  }
  
  button:disabled {
    cursor: default;
  }
  
  ul, ol, li {
    list-style-type: none;
  }
  
  strong {
    font-weight: bold;
  }
`;

export default function StyleResetProvider() {
  return <GlobalStyleProvider styles={globalStyles} />;
}
